import React from "react";
import { Routes, Route } from "react-router-dom";

import LandingPage from "./pages/Landingpage";
import AuthCallback from "./pages/Authcallback";
import JobListingPage from "./pages/JobListingPage";
import JobDetailPage from "./pages/JobDetailPage";
import JobFormPage from "./pages/JobFormPage";
import RoleSelectionPage from "./pages/RoleSelectionPage";
import RecruiterDashboardPage from "./pages/RecruiterDashboard";
import RecruiterOnboarding from "./pages/RecruiterOnboarding 1";
import RecruiterSuccess from "./pages/RecruiterSuccess";
import PlansPage from "./pages/PlansPage";
import RecruiterProfile from "./pages/RecruiterProfile";
import Candidateprofile from "./pages/ProfileHighlightPage";
import Candidatedetailprofile from "./pages/ProfileDetailPage";
import CandidateDashboard from "./pages/dashboard";
import Jobpreviewpage from "./components/Jobpreviewpage";
import PostedjobListing from "./pages/PostedjobListing";
import ApplicantsPage from "./pages/Applicantspage";
import Applicationstatus from "./pages/ApplicationStatusPage";
import Interview from "./pages/InterviewInvites";
import SavedJobs from "./pages/SavedJobs";


function App() {
  return (
    <Routes>

      {/*<Route path="/" element={<RoleSelectionPage />} />
      <Route path="/landingpage" element={<LandingPage />} />
       {/* Token from Common Module */}
       {/* Landing Page (Homepage) */}
      <Route path="/" element={<LandingPage />} />

      {/* Token from Common Module */}
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Role selection AFTER successful login */}
      <Route path="/role-selection" element={<RoleSelectionPage />} />
      
      <Route path="/jobs" element={<JobListingPage />} />
      <Route path="/job/:id" element={<JobDetailPage />} />
      <Route path="/post-job" element={<JobFormPage />} />
      <Route path="/recruiter-dashboard" element={<RecruiterDashboardPage />} />
      <Route path="/recruiter-onboarding" element={<RecruiterOnboarding />} />
      <Route path="/recruiter-profile" element={<RecruiterProfile />} />
      <Route path="/success" element={<RecruiterSuccess />} />
      <Route path="/plans" element={<PlansPage />} />
      <Route path="/candidate-onboarding" element={<Candidateprofile />} />
      <Route path="/candidate-profile" element={<Candidatedetailprofile />} />
      <Route path="/candidate-dashboard" element={<CandidateDashboard />} />
      <Route path="/job-preview" element={<Jobpreviewpage />} />
      <Route path="/applicants" element={<ApplicantsPage />} />
      <Route path="/applicants/:jobId" element={<ApplicantsPage />} />
      <Route path="/posted-joblist" element={<PostedjobListing />} />
      <Route path="/application-status" element={<Applicationstatus />} />
      <Route path="/interview-invite" element={<Interview/>}/>
      <Route path="/savedjobs" element={<SavedJobs/>}/>
    </Routes>
  );
}

export default App;
